const COMPLEXITY = {
  SIMPLE: 'Simple',
  COMPLEX: 'Advanced',
};

export const SIMPLE_PRODUCTS_COUNT = 3;

export default COMPLEXITY;
